export interface IDbLoginResult {
  access_token: string;
  token_type: string;
  expires_at: number;
  profile: {
    email: string;
    name: string;
  };
}

class DbAuthServiceClass {
  async login(email: string, password: string): Promise<IDbLoginResult> {
    const response = await fetch(`${environmentSettings.apiUrl}Auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'cache-control': 'no-cache'
      },
      cache: 'no-store',
      body: JSON.stringify({ email, password })
    });

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('Invalid email or password.');
      }
      throw new Error(`Sign in failed: ${response.status} ${response.statusText}`);
    }

    return response.json();
  }
}

export const DbAuthService = new DbAuthServiceClass();
export default DbAuthService;
